import { Ability } from '@casl/ability';

export const ability = new Ability([]); // Initialize with no rules